export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14134.ca3a622a.jpg";